export default __webpack_public_path__ + "assets/images/efaa3dded52eb946fcc28d82af52a53f.svg";